import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";
import {
  CREATE_FUEL_ADJUSTMENT_SUCCESS,
  FETCH_FUEL_ADJUSTMENT_SUCCESS,
  GET_FUEL_ADJUSTMENT_SUCCESS,
  SAVE_FUEL_ADJUSTMENT_QUERY
} from "../../constants/ActionTypes";
import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_FUEL_ADJUSTMENT_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_FUEL_ADJUSTMENT_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_FUEL_ADJUSTMENT_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_FUEL_ADJUSTMENT_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { fuelAdjustment } = store.getState();
      const { query } = fuelAdjustment;
      const response = await axios.get(`/fuel-adjustment?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { fuelAdjustment } = store.getState();
      const { query } = fuelAdjustment;
      const response = await axios.get(`/fuel-adjustment/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/fuel-adjustment`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
        message.success('Fuel adjustment created successfully');
        history.push('/fuel-adjustment');
        dispatch(getResource());
      }
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.message;
      message.error(msg || 'Failed to create fuel adjustment');
      dispatch(fetchError(msg || error));
      console.log("Error****:", error);
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/fuel-adjustment/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.delete(`/fuel-adjustment/${id}`);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
